<template>
  <div>
    <b-row>
      <b-col>
        <b-form-select
          @change="$emit('input', selectedNurse.usrId)"
          v-model="selectedNurse"
          :disabled="disabled"
        >
          <template v-if="!isNurseSelected" slot="first">
            <option :value="null" disabled
              >-- Bitte Hebamme auswählen --</option
            >
          </template>
          <option
            v-for="nurse in availableNurses"
            :key="nurse.usrId"
            :value="nurse"
          >
            {{ nurse.usrFirstName }} {{ nurse.usrLastName }}
          </option>
        </b-form-select>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button
          @click="assign(assignmentModes.PARTIALLY)"
          :disabled="!isNurseSelected || disabled"
          class="w-100 mb-3 mb-sm-0"
          >Teilweise zuweisen</b-button
        >
      </b-col>
      <b-col>
        <b-button
          @click="assign(assignmentModes.FULLY)"
          :disabled="!isNurseSelected || disabled || noFull"
          class="w-100"
          >Voll zuweisen</b-button
        >
      </b-col>
      <b-col>
        <b-button
          @click="showRemoveRequestModal()"
          variant="danger"
          :disabled="disabled"
          class="w-100"
          >Entfernen</b-button
        >
      </b-col>
    </b-row>
    <br />
    <b-row>
      <b-col>
        <b-alert
          dismissible
          @dismissed="removed = false"
          variant="success"
          :show="removed"
        >
          {{ message }}
        </b-alert>
        <b-alert
          dismissible
          @dismissed="error = ''"
          variant="danger"
          :show="error"
        >
          {{ errorMessage }}
        </b-alert>
      </b-col>
    </b-row>
    <remove-request-modal ref="modal-remove-request" :okFunction="remove" />
  </div>
</template>

<script>
import { assignmentModeEnum } from "../utils/enums";
import RemoveRequestModal from "./modals/RemoveRequestModal.vue";

export default {
  name: "RequestActionsAdmin",
  props: {
    availableNurses: Array,
    disabled: Boolean,
    noFull: Boolean
  },
  components: { RemoveRequestModal },
  data() {
    return {
      selectedNurse: null,
      assignmentModes: assignmentModeEnum,
      removed: false,
      error: false,
      message: "",
      errorMessage: ""
    };
  },
  computed: {
    isNurseSelected() {
      return Boolean(this.selectedNurse);
    }
  },
  methods: {
    assign(mode) {
      this.$emit("assign", mode);
      this.selectedNurse = null;
    },
    showRemoveRequestModal() {
      this.$refs["modal-remove-request"].show();
    },
    remove() {
      const data = new FormData();
      data.append("requestId", this.$route.params.id);
      this.$http
        .post("request/remove", data)
        .then(response => {
          this.message = response.data.message;
          this.removed = true;
          this.$router.push("/requests");
        })
        .catch(error => {
          this.error = true;
          this.errorMessage = error.response.data.message;
        })
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>

<style scoped>
select {
  margin-bottom: 15px;
}
</style>
